import { FC, ReactText } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Box, CircularProgressProps } from '@mui/material'

interface Props {
  centered?: boolean
  grow?: boolean
  color?: 'primary' | 'secondary' | 'inherit'
  size?: number
  style?: React.CSSProperties
}
const useStyle = makeStyles()(theme => ({
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', width: '100%' },
  spinner: { animation: 'rotation 2s infinite linear', width: 30, height: 30 },
}))
const SpinnerBase: React.FC<CircularProgressProps> = props => {
  const { classes } = useStyle()
  return <img src={'/images/circle.svg'} className={classes.spinner} style={props.style} />
}
export const CenteredSpinner: FC<Props> = props => {
  const { classes } = useStyle()
  return (
    <Box className={classes.container}>
      <SpinnerBase {...props} />
    </Box>
  )
}
interface SpinnerProps {
  size?: ReactText
  style?: any
  color?: string
  grow?: boolean
  justifyContent?: string
  alignItems?: string
}

export const Spinner: FC<SpinnerProps> = ({
  size,
  style,
  color = 'inherit',
  grow,
  justifyContent = 'center',
  alignItems = 'center',
}) => {
  const { classes } = useStyle()
  return (
    <Box
      display="flex"
      justifyContent={justifyContent}
      alignItems={alignItems}
      flexGrow={grow && 1}
      flex={grow && 1}
      height={'100%'}
    >
      <img src={'/images/circle.svg'} className={classes.spinner} style={style} />
    </Box>
  )
}
